import { render, staticRenderFns } from "./ModalMDB.vue?vue&type=template&id=137364ec&"
import script from "./ModalMDB.vue?vue&type=script&lang=js&"
export * from "./ModalMDB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports